import { createSlice } from '@reduxjs/toolkit';

// Helper function to load cart from localStorage
const loadCartFromStorage = () => {
  try {
    const cart = localStorage.getItem('cart');
    return cart ? JSON.parse(cart) : [];
  } catch (error) {
    console.error('Error loading cart from localStorage:', error);
    return [];
  }
};

// Helper function to save cart to localStorage
const saveCartToStorage = (cartItems) => {
  try {
    localStorage.setItem('cart', JSON.stringify(cartItems));
  } catch (error) {
    console.error('Error saving cart to localStorage:', error);
  }
};

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    cartItems: loadCartFromStorage(),
  },
  reducers: {
    addToCart: (state, action) => {
      const product  = action.payload;
      if(Array.isArray(product)){
        state.cartItems = product;
      }else{
        if(product.length === 0 ){
          return;
        }
        state.cartItems = [...state.cartItems, product];
      }

      saveCartToStorage(state.cartItems);
    },
    removeFromCart: (state, action) => {
      const productId = action.payload;
      state.cartItems = state.cartItems.filter(item => item._id !== productId);
      saveCartToStorage(state.cartItems);
    },
    updateQuantity: (state, action) => {
      // const { productId, quantity } = action.payload;
      // const item = state.cartItems.find(item => item._id === productId);

      // if (item) {
      //   if (quantity <= 0) {
      //     state.cartItems = state.cartItems.filter(item => item._id !== productId);
      //   } else {
      //     item.quantity = quantity;
      //   }
      //   saveCartToStorage(state.cartItems);
      // }
    },
    clearCart: (state) => {
      state.cartItems = [];
      saveCartToStorage(state.cartItems);
    },
  },
});

export const { addToCart, removeFromCart, updateQuantity, clearCart } = cartSlice.actions;

// Selectors
export const selectCartItems = (state) => state.cart.cartItems;
export const selectCartTotal = (state) =>  state.cart.cartItems.reduce((total, item) => total + item.price, 0);
export const selectCartItemCount = (state) =>  state.cart.cartItems.length;

export default cartSlice.reducer;